import { createContext } from 'react';
import utils from 'utils';
import { DownloadBannerPayload } from 'models/Download';

type DownloadStatusContextProps = {
  isAnalyticsExportInProgress: boolean;
  isLeadAnalyticsExportInProgress: boolean;
  isBossModeExportInProgress: boolean;
  isRfiCategoriesExportInProgress: boolean;
  isEnterpriseUsageReportExportInProgress: boolean;
  startFileDownload: () => void;
  failFileDownload: () => void;
  startReportDownload: (openInNewTab?: boolean) => void;
  failReportDownload: () => void;
  showAnalyticsExportInProgressBanner: () => void;
  startAnalyticsExportDownload: (
    customMessage?: string,
    openInNewTab?: boolean,
  ) => void;
  failAnalyticsExportDownload: () => void;
  startLeadAnalyticsExportDownload: (
    customMessage?: string,
    openInNewTab?: boolean,
  ) => void;
  failLeadAnalyticsExportDownload: () => void;
  startBossModeExportDownload: (customMessage?: string) => void;
  failBossModeExportDownload: () => void;
  startRfiCategoriesExportDownload: () => void;
  failRfiCategoriesExportDownload: () => void;
  startEnterpriseUsageReportExportDownload: () => void;
  failEnterpriseUsageReportExportDownload: () => void;
  showDownloadBanner: (payload: DownloadBannerPayload) => void;
};

export default createContext<DownloadStatusContextProps>({
  isAnalyticsExportInProgress: false,
  isLeadAnalyticsExportInProgress: false,
  isBossModeExportInProgress: false,
  isRfiCategoriesExportInProgress: false,
  isEnterpriseUsageReportExportInProgress: false,
  startFileDownload: utils.noop,
  failFileDownload: utils.noop,
  startReportDownload: utils.noop,
  failReportDownload: utils.noop,
  showAnalyticsExportInProgressBanner: utils.noop,
  startAnalyticsExportDownload: utils.noop,
  failAnalyticsExportDownload: utils.noop,
  startLeadAnalyticsExportDownload: utils.noop,
  failLeadAnalyticsExportDownload: utils.noop,
  startBossModeExportDownload: utils.noop,
  failBossModeExportDownload: utils.noop,
  startRfiCategoriesExportDownload: utils.noop,
  failRfiCategoriesExportDownload: utils.noop,
  startEnterpriseUsageReportExportDownload: utils.noop,
  failEnterpriseUsageReportExportDownload: utils.noop,
  showDownloadBanner: utils.noop,
});
